"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _questionnaireActions = require("../../../store/questionnaire/questionnaireActions");
var _uiActions = require("../../../store/ui/uiActions");
var _utils = require("../../../utils/utils");
var _analytics = require("../../analytics");
var _constants = require("../../../utils/constants");
var _errorActions = require("../../../store/error/errorActions");
var _services = require("../../../services");
class AnalyticsServiceENTEL extends _analytics.AnalyticsService {
  constructor(params) {
    super(params);
    this.questionsAnswers = {};
    this.stepData = '';
  }
  startJourney() {
    console.log('Entel Journey started ....');
  }
  _composeTaggingPageName(suffix) {
    return `${this.TAGGING_ID_PREFIX}:solution tool:${suffix}`;
  }
  _composeTaggingViewEvent(_ref) {
    var _currentQuestion$tagg, _currentQuestion$choi;
    let {
      pageName,
      eventLabel,
      eventName,
      currentProduct,
      currentQuestion
    } = _ref;
    const isPlan = (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.product_category) === 'plan' || (currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg === void 0 ? void 0 : _currentQuestion$tagg.questionType) === 'plan';
    const commonTags = {
      event: 'load',
      event_action: 'info',
      segment: isPlan ? 'po' : 'tm-equ',
      market: 'pe',
      page_category: 'recomendador',
      product_category: isPlan ? 'plan' : 'equipo'
    };
    if (eventName === 'onTransversalView' || eventName === 'onTransversalActionEvents') {
      return commonTags;
    }
    const isMixedJourney = currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$choi = currentQuestion.choices) === null || _currentQuestion$choi === void 0 ? void 0 : _currentQuestion$choi.some(choice => {
      var _choice$enable;
      return (_choice$enable = choice.enable) === null || _choice$enable === void 0 ? void 0 : _choice$enable.includes(_constants.FLAGS.BOTH_FLOW);
    });
    return {
      event_category: 'inicio',
      event_label: eventLabel,
      title: pageName === null || pageName === void 0 ? void 0 : pageName.toLowerCase(),
      ...(!isMixedJourney && {
        visitor_type: 'nn'
      }),
      ...this.questionsAnswers,
      ...commonTags
    };
  }
  _composeTaggingActionEvent(_ref2) {
    let {
      pageName,
      eventLabel,
      eventName,
      currentProduct,
      currentQuestion,
      stepIndex
    } = _ref2;
    const {
      taggingMetadata
    } = currentQuestion !== null && currentQuestion !== void 0 ? currentQuestion : {};
    let stepData = `paso ${stepIndex}`;
    this.stepData = taggingMetadata !== null && taggingMetadata !== void 0 && taggingMetadata.stepName ? stepData + ` - ${taggingMetadata.stepName}` : stepData;
    return {
      ...this._composeTaggingViewEvent({
        pageName,
        eventLabel,
        eventName,
        currentProduct,
        currentQuestion
      }),
      event: 'click_to_action',
      event_category: 'btn',
      event_action: 'click_to_action',
      form_step_name: this.stepData
    };
  }
  getSelectedOptions(selectedOptionEvent, taggingMetadata) {
    return [...selectedOptionEvent].map(selection => {
      var _taggingMetadata$tagA;
      if (!(taggingMetadata !== null && taggingMetadata !== void 0 && taggingMetadata.tagAnswerMapping)) return selection;
      const mapped = (_taggingMetadata$tagA = taggingMetadata.tagAnswerMapping) === null || _taggingMetadata$tagA === void 0 ? void 0 : _taggingMetadata$tagA[selection === null || selection === void 0 ? void 0 : selection.trim()];
      return mapped || taggingMetadata.tagAnswerMapping.default || selection;
    });
  }
  getRoamingTaggingData(_ref3) {
    let {
      taggingMetadata,
      selectedOptions,
      eventName
    } = _ref3;
    if (eventName === 'onToolView') {
      return `${this.questionsAnswers[taggingMetadata === null || taggingMetadata === void 0 ? void 0 : taggingMetadata.tagKey].split('/')[0].trim()} / ${selectedOptions.map(s => typeof s === 'string' ? (0, _utils.replaceSpanishCharacter)(s.toLowerCase()) : s).join(' / ')}`;
    } else if (eventName === 'onToolAnswer') {
      var _this$questionsAnswer, _this$questionsAnswer2;
      return `${((_this$questionsAnswer = this.questionsAnswers[taggingMetadata === null || taggingMetadata === void 0 ? void 0 : taggingMetadata.tagKey]) === null || _this$questionsAnswer === void 0 ? void 0 : (_this$questionsAnswer2 = _this$questionsAnswer.split('/')[0]) === null || _this$questionsAnswer2 === void 0 ? void 0 : _this$questionsAnswer2.trim()) || ''} / ${selectedOptions.map(s => typeof s === 'string' ? (0, _utils.replaceSpanishCharacter)(s.toLowerCase()) : s).join(' / ')}`;
    }
  }
  _adjustQuestionAnswersMetadata(_ref4) {
    let {
      currentQuestion,
      selectedOptionEvent,
      flags
    } = _ref4;
    const {
      taggingMetadata,
      type
    } = currentQuestion !== null && currentQuestion !== void 0 ? currentQuestion : {};
    if (!taggingMetadata || !selectedOptionEvent.length) return;
    let selectedOptions = this.getSelectedOptions(selectedOptionEvent, taggingMetadata);
    if (type === 'multi') {
      selectedOptions = [];
      currentQuestion.multi.forEach((c, i) => {
        var _taggingMetadata$tagT, _c$rangeTitle;
        const choiceTitle = taggingMetadata === null || taggingMetadata === void 0 ? void 0 : (_taggingMetadata$tagT = taggingMetadata.tagTitlesMapping) === null || _taggingMetadata$tagT === void 0 ? void 0 : _taggingMetadata$tagT[(_c$rangeTitle = c.rangeTitle) === null || _c$rangeTitle === void 0 ? void 0 : _c$rangeTitle.trim()];
        const selectedChoiceIndex = c.rangeChoices.labels.findIndex(el => el.value == selectedOptionEvent[i]);
        if (selectedChoiceIndex === -1) return;
        selectedOptions.push(`${choiceTitle || c.rangeTitle} ${selectedChoiceIndex}`);
      });
    }
    if (!(flags !== null && flags !== void 0 && flags.newCustomer) && taggingMetadata.stepName === 'roaming') {
      return this.questionsAnswers[taggingMetadata === null || taggingMetadata === void 0 ? void 0 : taggingMetadata.tagKey] = this.getRoamingTaggingData({
        taggingMetadata,
        selectedOptions,
        eventName: 'onToolView'
      });
    }
    this.questionsAnswers = {
      ...this.questionsAnswers,
      ...((taggingMetadata === null || taggingMetadata === void 0 ? void 0 : taggingMetadata.tagKey) && {
        [taggingMetadata === null || taggingMetadata === void 0 ? void 0 : taggingMetadata.tagKey]: selectedOptions.map(s => typeof s === 'string' ? (0, _utils.replaceSpanishCharacter)(s.toLowerCase()) : s).join(' / ')
      })
    };
  }
  _composeQuestionAnswersMetadata(_ref5) {
    let {
      currentQuestion,
      selectedOptionEvent,
      stepIndex,
      flags
    } = _ref5;
    const {
      taggingMetadata,
      type
    } = currentQuestion !== null && currentQuestion !== void 0 ? currentQuestion : {};
    if (!taggingMetadata || !selectedOptionEvent.length) return;
    let selectedOptions = this.getSelectedOptions(selectedOptionEvent, taggingMetadata);
    if (type === 'multi') {
      selectedOptions = [];
      currentQuestion.multi.forEach((c, i) => {
        var _taggingMetadata$tagT2, _c$rangeTitle2;
        const choiceTitle = taggingMetadata === null || taggingMetadata === void 0 ? void 0 : (_taggingMetadata$tagT2 = taggingMetadata.tagTitlesMapping) === null || _taggingMetadata$tagT2 === void 0 ? void 0 : _taggingMetadata$tagT2[(_c$rangeTitle2 = c.rangeTitle) === null || _c$rangeTitle2 === void 0 ? void 0 : _c$rangeTitle2.trim()];
        const selectedChoiceIndex = c.rangeChoices.labels.findIndex(el => el.value == selectedOptionEvent[i]);
        if (selectedChoiceIndex === -1) return;
        selectedOptions.push(`${choiceTitle || c.rangeTitle} ${selectedChoiceIndex}`);
      });
    }
    if (taggingMetadata.stepName === 'roaming' && flags.isCustomer) {
      this.questionsAnswers[taggingMetadata === null || taggingMetadata === void 0 ? void 0 : taggingMetadata.tagKey] = this.getRoamingTaggingData({
        taggingMetadata,
        selectedOptions,
        eventName: 'onToolAnswer'
      });
    } else {
      this.questionsAnswers = {
        ...this.questionsAnswers,
        ...((taggingMetadata === null || taggingMetadata === void 0 ? void 0 : taggingMetadata.tagKey) && {
          [taggingMetadata === null || taggingMetadata === void 0 ? void 0 : taggingMetadata.tagKey]: selectedOptions.map(s => typeof s === 'string' ? (0, _utils.replaceSpanishCharacter)(s.toLowerCase()) : s).join(' / ')
        })
      };
    }
    let stepData = `paso ${stepIndex}`;
    if (taggingMetadata.stepName) stepData = stepData + ` - ${taggingMetadata.stepName}`;
    this.stepData = stepData;
  }
  getPlanPrice(variant, costs) {
    return {
      productPrice: costs === null || costs === void 0 ? void 0 : costs.totalTermCost,
      productSubprice: costs === null || costs === void 0 ? void 0 : costs.totalTermCostBeforeDiscount
    };
  }
  showDiscount(flags) {
    return flags === null || flags === void 0 ? void 0 : flags[_constants.FLAGS.IS_CUSTOMER];
  }
  _getProductData(product, costs, flags) {
    var _upfrontPrice$discoun, _upfrontPrice$discoun2, _variant$characterist, _skuId, _skuId$find, _skuId2, _skuId2$, _skuId3;
    if (!product) return {};
    const variant = product.selectedVariant;
    const brand = variant.characteristics.find(c => c.id === 'brand') || {};
    const upfrontPrice = variant.price.find(c => c.priceType === _constants.PRICE_TYPES.UP_FRONT) || {};
    const price = this.showDiscount(flags) ? (_upfrontPrice$discoun = upfrontPrice === null || upfrontPrice === void 0 ? void 0 : (_upfrontPrice$discoun2 = upfrontPrice.discount) === null || _upfrontPrice$discoun2 === void 0 ? void 0 : _upfrontPrice$discoun2.totalDiscountValue) !== null && _upfrontPrice$discoun !== void 0 ? _upfrontPrice$discoun : upfrontPrice === null || upfrontPrice === void 0 ? void 0 : upfrontPrice.priceValue : upfrontPrice === null || upfrontPrice === void 0 ? void 0 : upfrontPrice.priceValue;
    const recurringPrice = this.showDiscount(flags) ? variant.price.find(_ref6 => {
      let {
        priceType
      } = _ref6;
      return priceType === _constants.PRICE_TYPES.RECURRING;
    }) || {} : {};
    let product_price = price;
    let product_subprice = recurringPrice.priceValue;
    if (product.productType === 'plan') {
      const {
        productPrice,
        productSubprice
      } = this.getPlanPrice(variant, costs);
      product_price = productPrice;
      product_subprice = productSubprice;
    }
    let skuId = (_variant$characterist = variant.characteristics.find(c => c.id === 'skuId')) === null || _variant$characterist === void 0 ? void 0 : _variant$characterist.value;
    skuId = ((_skuId = skuId) === null || _skuId === void 0 ? void 0 : _skuId.length) > 1 ? (_skuId$find = skuId.find(s => s.isDefault)) === null || _skuId$find === void 0 ? void 0 : _skuId$find.value : (_skuId2 = skuId) === null || _skuId2 === void 0 ? void 0 : (_skuId2$ = _skuId2[0]) === null || _skuId2$ === void 0 ? void 0 : _skuId2$.value;
    return {
      product_id: (_skuId3 = skuId) !== null && _skuId3 !== void 0 ? _skuId3 : product.productId.split('-')[0],
      product_brand: (brand === null || brand === void 0 ? void 0 : brand.valueText) && (0, _utils.replaceSpanishCharacter)(brand.valueText.toLowerCase()),
      product_name: (product === null || product === void 0 ? void 0 : product.productName) && (0, _utils.replaceSpanishCharacter)(product.productName.toLowerCase()),
      product_price: product_price,
      product_subprice: product_subprice,
      product_category: product.productType === 'plan' ? 'plan' : 'equipo'
    };
  }
  composeTaggingEvents(_ref7) {
    var _currentQuestion$tagg2, _currentQuestion$tagg3;
    let {
      pageName,
      eventLabel,
      stepIndex,
      eventName,
      selectedOptionEvent,
      currentQuestion,
      currentProduct,
      costs,
      noOfPlans,
      title,
      flags
    } = _ref7;
    if (eventName === 'onToolAnswer') {
      this._composeQuestionAnswersMetadata({
        currentQuestion,
        selectedOptionEvent,
        stepIndex,
        flags
      });
      return {};
    }
    if (eventName === 'onToolView') {
      this._adjustQuestionAnswersMetadata({
        currentQuestion,
        selectedOptionEvent,
        stepIndex,
        flags
      });
      return {};
    }
    const taggingEventProps = {
      pageName,
      eventLabel,
      eventName,
      currentProduct,
      currentQuestion,
      stepIndex
    };
    let eventViewTag = this._composeTaggingViewEvent(taggingEventProps);
    let eventActionTag = this._composeTaggingActionEvent(taggingEventProps);
    if ((currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.if) === 'plan' || (currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg2 = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg2 === void 0 ? void 0 : _currentQuestion$tagg2.questionType) === 'plan') {
      eventActionTag['product_category'] = 'plan';
      eventActionTag['segment'] = 'po';
      ['product_brand'].forEach(e => delete eventActionTag[e]);
    }
    if (eventName === 'onTransversalActionEvents') {
      this.questionsAnswers = {};
      this.stepData = '';
      ['variant_1', 'variant_2', 'description', 'product_brand', 'product_price'].forEach(e => delete eventViewTag[e]);
    }
    if (currentQuestion !== null && currentQuestion !== void 0 && (_currentQuestion$tagg3 = currentQuestion.taggingMetadata) !== null && _currentQuestion$tagg3 !== void 0 && _currentQuestion$tagg3.keysToBeRemoved) {
      var _currentQuestion$tagg4;
      currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg4 = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg4 === void 0 ? void 0 : _currentQuestion$tagg4.keysToBeRemoved.forEach(e => {
        delete eventActionTag[e];
        delete this.questionsAnswers[e];
      });
    }

    // remove unnecessary keys from result
    const eventsKeysToRemoveOnResult = ['onToolResult', 'onToolResultNext', 'onToolResultTabSwitch', 'onToolCompare', 'onAdditionalPlanUpdate'];
    if (eventsKeysToRemoveOnResult.includes(eventName)) {
      const keysToRemove = {};
      Object.keys(this.questionsAnswers).forEach(k => {
        if (k === 'visitor_type') return;
        keysToRemove[k] = undefined;
      });
      eventViewTag = {
        ...eventViewTag,
        ...keysToRemove
      };
      eventActionTag = {
        ...eventActionTag,
        ...keysToRemove
      };
    }
    const productTier = currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.tier;
    const currentProductSpanishTier = _services.locale.localeString(`Recommendation.${productTier}`).toLowerCase();
    const productData = this._getProductData(currentProduct, costs, flags);
    let basketTagging = {};
    if (eventName === 'onToolCheckout') {
      ['variant_1', 'variant_2', 'description', 'variant_3'].forEach(e => delete eventActionTag[e]);
      basketTagging = {
        ...eventActionTag,
        level_1: currentProductSpanishTier,
        form_step_name: `paso ${stepIndex} - conversion`,
        product_subprice: productData === null || productData === void 0 ? void 0 : productData.product_subprice,
        product_price: productData === null || productData === void 0 ? void 0 : productData.product_price,
        event_label: (productData === null || productData === void 0 ? void 0 : productData.productType) === 'plan' ? _services.locale.localeString('Questionnaire.ButtonChoosePlan').toLowerCase() : _services.locale.localeString('Recommendation.ButtonNext').toLowerCase(),
        title: currentProductSpanishTier,
        product_brand: productData.product_brand,
        product_id: productData.product_id.split('-')[0],
        product_name: productData.product_name,
        ...(productData.product_category !== 'plan' && {
          event_name: 'tool_success'
        }),
        status: 'exito'
      };
      // saving basket tgging in loacl storage
      window.localStorage.setItem('basketTagging', JSON.stringify(basketTagging));
    }
    return {
      onToolStart: {
        ...eventViewTag,
        event_name: 'tool_start'
      },
      onToolNext: eventActionTag,
      onToolBack: eventActionTag,
      onToolRestart: {},
      onToolEnd: {
        ...eventViewTag,
        event_name: 'tool_end'
      },
      onToolResult: {
        ...eventViewTag,
        event_label: 'carga',
        ...(productData.product_category !== 'plan' && {
          event_name: 'tool_success'
        }),
        event_category: 'conversion',
        status: 'exito',
        title: currentProductSpanishTier,
        level_1: currentProductSpanishTier,
        form_step_name: `paso ${stepIndex} - conversion`,
        product_quantity: this.questionsAnswers.product_quantity,
        segment: productData.product_category === 'plan' ? 'po' : 'tm-equ',
        ...productData
      },
      onToolResultNext: {
        ...eventActionTag,
        event_label: 'continuar',
        status: 'exito',
        title: currentProductSpanishTier,
        level_1: currentProductSpanishTier,
        page_category: 'recomendador',
        form_step_name: `paso ${stepIndex} - conversion`,
        ...productData
      },
      onToolResultTabSwitch: {
        ...eventActionTag,
        event_label: currentProductSpanishTier,
        ...(productData.product_category !== 'plan' && {
          event_name: 'tool_success'
        }),
        event_category: 'tab',
        event: 'interaction',
        event_action: 'interaction',
        status: 'exito',
        title: currentProductSpanishTier,
        level_1: currentProductSpanishTier,
        form_step_name: `paso ${stepIndex} - conversion`,
        product_quantity: this.questionsAnswers.product_quantity,
        segment: productData.product_category === 'plan' ? 'po' : 'tm-equ',
        ...productData
      },
      onToolCompare: {
        ...eventActionTag,
        event_label: productData.product_category === 'plan' ? 'Comparar planes' : 'Comparar aparatos',
        status: 'exito',
        title: currentProductSpanishTier,
        level_1: currentProductSpanishTier,
        page_category: 'recomendador',
        form_step_name: `paso ${stepIndex} - conversion`,
        event_name: 'tool_success',
        segment: productData.product_category === 'plan' ? 'po' : 'tm-equ',
        ...productData
      },
      onToolCheckout: {
        ...basketTagging,
        segment: productData.product_category === 'plan' ? 'po' : 'tm-equ',
        product_category: productData.product_category === 'plan' ? 'plan' : 'equipo'
      },
      onAdditionalPlanUpdate: {
        ...eventActionTag,
        event_label: `${noOfPlans} plan`,
        event_category: 'checkbox',
        event: 'interaction',
        event_action: 'interaction',
        title: currentProductSpanishTier,
        level_1: currentProductSpanishTier,
        form_step_name: `paso ${stepIndex} - conversion`,
        product_quantity: noOfPlans || this.questionsAnswers.product_quantity,
        segment: productData.product_category === 'plan' ? 'po' : 'tm-equ',
        ...productData
      },
      onTransversalView: {
        ...eventViewTag,
        event_category: 'error',
        event_label: 'carga',
        title: title ? (0, _utils.replaceSpanishCharacter)(title.toLowerCase()) : ''
      },
      onTransversalActionEvents: {
        ...eventViewTag,
        event: 'click_to_action',
        event_category: 'error',
        event_action: 'click_to_action',
        event_label: eventLabel ? (0, _utils.replaceSpanishCharacter)(eventLabel.toLowerCase()) : '',
        title: title ? (0, _utils.replaceSpanishCharacter)(title.toLowerCase()) : ''
      }
    };
  }
  getEventsName() {
    return {
      [_uiActions.OPEN_GUIDED_SELLING_MODAL]: {
        eventName: 'onToolStart',
        stepIndex: 0,
        eventLabel: 'carga',
        pageName: 'inicio'
      },
      [_questionnaireActions.VIEW_QUESTION]: {
        eventName: 'onToolView'
      },
      [_questionnaireActions.GOTO_NEXT_QUESTION]: {
        eventName: 'onToolNext',
        eventLabel: 'continuar'
      },
      // [GOTO_PREVIOUS_QUESTION]: { eventName: 'onToolBack', eventLabel: 'volver' },
      // [RESET_QUESTIONNAIRE]: { eventName: 'onToolRestart', eventLabel: 'reinicio' },
      [_questionnaireActions.ADD_SELECTION]: {
        eventName: 'onToolAnswer'
      },
      [_questionnaireActions.REPLACE_SELECTION]: {
        eventName: 'onToolAnswer'
      },
      [_questionnaireActions.REMOVE_SELECTION]: {
        eventName: 'onToolAnswer'
      },
      [_errorActions.API_CALL_ERROR]: {
        eventName: 'onTransversalView',
        title: _services.locale.localeString('ErrorPage.Heading')
      },
      [_errorActions.SET_RETRY_IN_PROGRESS]: {
        eventName: 'onTransversalActionEvents',
        eventLabel: _services.locale.localeString('ErrorPage.Button'),
        title: _services.locale.localeString('ErrorPage.Heading')
      },
      [_questionnaireActions.RESET_QUESTIONNAIRE_ON_ERROR]: {
        eventName: 'onTransversalActionEvents',
        eventLabel: _services.locale.localeString('ErrorPage.RetryButton'),
        title: _services.locale.localeString('ErrorPage.Heading')
      },
      [_questionnaireActions.RESET_QUESTIONNAIRE_ON_CONFIRM_MESSAGE]: {
        eventName: 'onTransversalActionEvents',
        eventLabel: _services.locale.localeString('WarningScreen.ConfirmButton'),
        title: _services.locale.localeString('WarningScreen.Heading')
      },
      [_uiActions.GO_TO_DYNAMIC_PAGE]: {
        eventName: 'onTransversalView',
        title: _services.locale.localeString('WarningScreen.Heading')
      }
    };
  }
  getQuestionnaireEventData(currentViewQuestionIndex, pageTitle) {
    return {
      pageName: pageTitle ? (0, _utils.replaceSpanishCharacter)(pageTitle) : '',
      stepIndex: currentViewQuestionIndex + 1
    };
  }
}
var _default = AnalyticsServiceENTEL;
exports.default = _default;